import * as React from 'react';

export const HttpError = () => (
    <svg width="180px" height="140px" viewBox="0 0 180 140" version="1.1">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="http-overlay" transform="translate(-681.000000, -112.000000)">
                <g id="Browser---User-Management----Invite-new-user" transform="translate(681.000000, 112.000000)">
                    <path d="M4,0 L176,0 C178.209139,-4.05812251e-16 180,1.790861 180,4 L180,136 C180,138.209139 178.209139,140 176,140 L4,140 C1.790861,140 2.705415e-16,138.209139 0,136 L0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 Z" id="Rectangle-4" fill="#EAF3FB"/>
                    <path d="M56,43 L123,43 C124.656854,43 126,44.3431458 126,46 L126,113 C126,114.656854 124.656854,116 123,116 L56,116 C54.3431458,116 53,114.656854 53,113 L53,46 C53,44.3431458 54.3431458,43 56,43 Z" id="Rectangle" stroke="#368CD7" strokeWidth="2" fill="#FFFFFF"/>
                    <g id="Stroke-2987" transform="translate(78.000000, 68.000000)" fill="#368CD7" fillOpacity="0.150000006" stroke="#368CD7" strokeLinejoin="round" strokeWidth="1.5">
                        <polygon points="7.5 12 0.5 19 5 23.5 12 16.5 19 23.5 23.5 19 16.5 12 23.5 5 19 0.5 12 7.5 5 0.5 0.5 5"/>
                    </g>
                    <path d="M4,0 L176,0 C178.209139,-4.05812251e-16 180,1.790861 180,4 L180,20 L180,20 L0,20 L0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 Z" id="Rectangle-4" fill="#368CD7"/>
                    <circle id="Oval" fill="#FFFFFF" cx="11" cy="11" r="3"/>
                    <circle id="Oval" fill="#FFFFFF" cx="20" cy="11" r="3"/>
                    <circle id="Oval" fill="#FFFFFF" cx="29" cy="11" r="3"/>
                </g>
            </g>
        </g>
    </svg>
);
